// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"20c1eb98","719":"21f8be6c","829":"be815bd4","919":"1c452a49"}[chunkId] + ".chunk.js";
};